import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './styles';

const MessageBox = (props) => {
  const classNames = cx(props.className, {
    [styles.messageBox]: true,
    [styles.error]: props.error,
  });
  return (
    <div className={classNames}>
      <strong>{props.message}</strong>
      {props.children}
    </div>
  );
};

MessageBox.propTypes = {
  error: PropTypes.bool,
  message: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default MessageBox;



// WEBPACK FOOTER //
// ./client/app/shared/components/MessageBox/index.jsx